import React, { useState, useContext } from 'react';
import propTypes from 'prop-types';
import css from 'classnames';

import FormContext from '../context/formContext';
import useWidgetLayout from '../../hooks/useWidgetLayout';
import useAPICarData from '../../hooks/useAPICarData';
import useFormActions from '../../hooks/useFormAction';
import SelectBox from '../select-box';
import FormResults from '../form-results';

import styles from './form.module.css';

const CalculatorForm = ({ gtm }) => {
  const [result, setResult] = useState();
  const { state, dispatch } = useContext(FormContext);

  const {
    handleSubmit, // From 'useForm' hook
    handleOnSubmit,
    handleChange,
    handleResetForm,
    getValues,
    errors,
    updatedSelect,
    showResults,
  } = useFormActions(state.year, setResult, dispatch, gtm);

  // Get the car data from the API (for select options, and the final result)
  useAPICarData(updatedSelect, getValues, state, dispatch);

  const orientation = useWidgetLayout();

  const formButtonText =
    showResults && state.formIsDirty
      ? 'Update company car tax details'
      : 'View company car tax details';

  // Setup the main config object for the select boxes.
  // We loop over this in the render to build each select box.
  const selectBoxesConfig = {
    make: {
      name: 'make',
      options: state.make,
      error: errors.make,
      isLoading: !state.make.length,
    },
    model: {
      name: 'model',
      options: state.model,
      disabled: !getValues('make'),
      isLoading: getValues('make') && !state.model.length,
      error: getValues('make') && errors.model,
    },
    version: {
      name: 'version',
      options: state.version,
      disabled: !getValues('model'),
      isLoading: getValues('model') && !state.version.length,
      error: getValues('model') && errors.version,
    },
    year: {
      name: 'year',
      options: state.year,
    },
  };

  return (
    <>
      <form
        onSubmit={handleSubmit(handleOnSubmit(state.selectedVersion))}
        className={css([styles.form, styles[orientation]])}
        role='form'
      >
        {Object.values(selectBoxesConfig).map(
          ({ name, options, disabled, error, isLoading }) => {
            const selectClassName = `selectContainer${name
              .charAt(0)
              .toUpperCase()}${name.slice(1)}`;
            return (
              <SelectBox
                key={name}
                name={name}
                value={getValues(name)}
                options={options}
                disabled={disabled}
                isLoading={isLoading}
                handleChange={handleChange}
                error={error}
                selectNameStyle={styles[selectClassName]}
              />
            );
          },
        )}
        <button type='submit' className={styles.submit}>
          {formButtonText}
        </button>
      </form>

      {showResults && (
        <FormResults handleResetForm={handleResetForm} result={result} />
      )}
    </>
  );
};

CalculatorForm.propTypes = {
  gtm: propTypes.func,
};

export default CalculatorForm;
